export default "__VITE_ASSET__BXWTmncE__"